import React from 'react';
import '../applications-css/Application.css'
import "../applications-css/Minesweeper.css";
const flagEmoji = <span role="img" aria-label="flag">🏴</span>

class Minesweeper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 10,
      width: 10,
      numOfMines: 10,
      spacesRemaining: 0,
      flagsOnBoard: 0,
      flagsEnabled: false,
      actualBoard: []
    }
    this.cellClickHandler = this.cellClickHandler.bind(this);
  }

  componentDidMount() {
    let array = [];
    let mineLocations = [];
    this.create2dBoard(array);
    this.createMines(array, mineLocations);
    this.createNumberSpaces(array, mineLocations);
    this.setState({
      spacesRemaining: this.state.height * this.state.width,
      actualBoard: array
    });
  }

  flagHandler() {
    let button = this.refs.flagsButton;
    if(this.state.flagsEnabled === true) {
      button.setAttribute("class", "unclickedButton");
    }
    else {
      button.setAttribute("class", "clickedButton");
    }
    this.setState({
      flagsEnabled: !this.state.flagsEnabled,
    })
  }

  cellClickHandler(location) {
    if(this.state.flagsEnabled === true) {
      this.flagCellClick(location);
    }
    else {
      this.regularCellClick(location);
    }
  }

  flagCellClick(location) {
    let newArray = this.state.actualBoard;
    let x = location[0];
    let y = location[1];
    newArray[x][y].isFlagged = !newArray[x][y].isFlagged;
    let newflagsOnBoard = this.countSpacesFlagged(newArray);
    this.setState({
      flagsOnBoard: newflagsOnBoard,
      actualBoard: newArray
    })
  }

  regularCellClick(location) {
    let newArray = this.state.actualBoard;
    let newSpacesRemaining = this.state.spacesRemaining;
    let x = location[0];
    let y = location[1];
    let cellValue = newArray[x][y].actualValue;
    newArray[x][y].isRevealed = true;
    if(cellValue === "X") {
      this.revealBoard();
      this.props.appLauncherHandler(null, "Popup Window", this.loseMessage);
    }
    else {
      if(newArray[x][y].isFlagged === true) {
        newArray[x][y].isFlagged = false;
      }
      if(cellValue === " ") {
        let tempArray = this.state.actualBoard;
        this.cellTraversal(tempArray, location);
        newSpacesRemaining = this.countSpacesRevealed(tempArray)
      }
      else {
        newSpacesRemaining--;
      }
      if(newSpacesRemaining === 10) {
        this.props.appLauncherHandler(null, "Popup Window", this.winMessage);
      }
      let newflagsOnBoard = this.countSpacesFlagged(newArray);
      this.setState({
        flagsOnBoard: newflagsOnBoard,
        spacesRemaining: newSpacesRemaining,
        actualBoard: newArray
      })
    }
  }

  cellTraversal(tempArray, startingLocation) {
    let x = startingLocation[0];
    let y = startingLocation[1];
    if(this.isValidSpace(x, y) && tempArray[x][y].actualValue !== " ") {
      tempArray[x][y].isRevealed = true;
    }
    else {
      let surroundingSpaces = [
        [x - 1, y - 1], [x - 1, y], [x - 1, y + 1],
        [x, y - 1], [x, y + 1],
        [x + 1, y - 1], [x + 1, y], [x + 1, y + 1]
      ]
      for(let i = 0; i < surroundingSpaces.length; i++) {
        x = surroundingSpaces[i][0];
        y = surroundingSpaces[i][1];
        if(this.spaceValidAndUnrevealed(tempArray, x, y)) {
          tempArray[x][y].isRevealed = true;
          tempArray[x][y].isFlagged = false;
          this.cellTraversal(tempArray, [x, y]);
        }
      }
    }
  }

  spaceValidAndUnrevealed(tempArray, x, y) {
    if(this.isValidSpace(x, y) && tempArray[x][y].isRevealed === false) {
      return true;
    }
    else {
      return false;
    }
  }

  getRandomNumber(min, max) {
    let rand = min + (Math.random() * (max - min));
    rand = Math.floor(rand);
    return rand;
  }

  isValidSpace(x, y) {
    if(x > this.state.width - 1 || y > this.state.height - 1) {
      return false;
    }
    else if(x < 0 || y < 0) {
      return false;
    }
    else {
      return true;
    }
  }

  create2dBoard(array) {
    for(let i = 0; i < this.state.width; i++) {
      let newRow = new Array(this.state.height);
      for(let j = 0; j < this.state.height; j++) {
        newRow[j] = {
          isRevealed: false,
          isFlagged: false,
          actualValue: " "
        }
      }
      array.push(newRow);
    }
  }

  createMines(array, mineLocations) {
    let currentMines = 0;
    while(currentMines < this.state.numOfMines) {
      let xCoordinate = this.getRandomNumber(0, this.state.width - 1)
      let yCoordinate = this.getRandomNumber(0, this.state.height - 1);
      if(array[xCoordinate][yCoordinate].actualValue !== "X") {
        array[xCoordinate][yCoordinate].actualValue = "X";
        mineLocations.push([xCoordinate, yCoordinate]);
        currentMines++;
      }
    }
    mineLocations.sort();
    // console.log(mineLocations);
  }

  createNumberSpaces(array, mineLocations) {
    // for each mine in the list
    for(let i = 0; i < this.state.numOfMines; i++) {
      let x = mineLocations[i][0];
      let y = mineLocations[i][1];
      // get list of each surrounding space
      let surroundingSpaces = [
        [x - 1, y - 1], [x - 1, y], [x - 1, y + 1],
        [x, y - 1], [x, y + 1],
        [x + 1, y - 1], [x + 1, y], [x + 1, y + 1]
      ]
      // then for each space in the list, check validity and set the array space to numberSpacesCheck()
      for(let j = 0; j < surroundingSpaces.length; j++) {
        x = surroundingSpaces[j][0];
        y = surroundingSpaces[j][1];
        if(this.isValidSpace(x, y)) {
          let spaceValue = array[x][y].actualValue;
          array[x][y].actualValue = this.numberSpacesCheck(spaceValue);
        }
      }
    }
  }

  numberSpacesCheck(spaceValue) {
    if(spaceValue === "X") {
      return "X";
    }
    else if(spaceValue === " ") {
      return 1;
    }
    else {
      return spaceValue + 1;
    }
  }

  countSpacesRevealed(board) {
    let newSpacesRemaining = this.state.width * this.state.height;
    for(let i = 0; i < this.state.width; i++) {
      for(let j = 0; j < this.state.height; j++) {
        if(board[i][j].isRevealed === true) {
          newSpacesRemaining--;
        }
      }
    }
    return newSpacesRemaining;
  }

  countSpacesFlagged(board) {
    let spacesFlagged = 0;
    for(let i = 0; i < this.state.width; i++) {
      for(let j = 0; j < this.state.height; j++) {
        if(board[i][j].isFlagged === true) {
          spacesFlagged++;
        }
      }
    }
    return spacesFlagged;
  }


  revealBoard() {
    let newArray = this.state.actualBoard;
    for(let i = 0; i < this.state.width; i++) {
      for(let j = 0; j < this.state.height; j++) {
        newArray[i][j].isRevealed = true;
      }
    }
    this.setState({
      actualBoard: newArray
    })
  }

  loseMessage() {
    return(
      <span>
        <img src={null} draggable="false" alt={""}/>
        <p>You lose! Open a new window to play again.</p>
      </span>
    );
  }

  winMessage() {
    return(
      <span>
        <img src={null} draggable="false" alt={""}/>
        <p>You win! Open a new window to play again.</p>
      </span>
    );
  }

  createBoard() {
    let flagsEnabled = this.state.flagsEnabled;
    let cellClickHandler = this.cellClickHandler;
    return(
      <div id="minesweeperGrid">
      {this.state.actualBoard.map(function(row, xIndex) {
        return row.map(function(cell, yIndex) {
          return(
            <MinesweeperSquare
              location={[xIndex, yIndex]}
              actualValue={cell.actualValue}
              isFlagged ={cell.isFlagged}
              isRevealed={cell.isRevealed}
              flagsEnabled={flagsEnabled}
              cellClickHandler = {cellClickHandler}
              key={[xIndex, yIndex]}/>
          );
        })
      })}
      </div>
    )
  }

  render() {
    let minesFlagged = 10 - this.state.flagsOnBoard;
    if(minesFlagged < 0) {
      minesFlagged = 0;
    }
    return(
      <div id="minesweeperWrapper" className="outsideWrapper">
        <div id="minesweeperHeader">
          <button className="unclickedButton" data-testid="mines-found" style={{pointerEvents: "none",}}>
            {minesFlagged}
          </button>
          <button className="unclickedButton" ref="flagsButton"
            data-testid="button-flag"
            onClick = {() => this.flagHandler()}>
              {flagEmoji}
          </button>
        </div>
        {this.createBoard()}
      </div>
    )
  }
}

class MinesweeperSquare extends React.Component {
  constructor(props) {
    super(props);
    this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler(location) {
    if(this.props.flagsEnabled === false) {
      this.showButtonClicked();
    }
    this.props.cellClickHandler(location);
  }

  showButtonClicked() {
    let button = this.refs.minesweeperButton;
    button.setAttribute("class", "clickedButton");
  }

  getCellColor() {
    let cell = this.props.actualValue;
    switch(cell) {
      case 1:
        return "blue";
      case 2:
        return "green";
      case 3:
        return "red";
      case 4:
        return "blue";
      case 5:
        return "maroon";
      case 6:
        return "teal";
      case 7:
        return "black";
      case 8:
        return "darkgrey";
      default:
        return null;
    }
  }

  render() {
    let pointerEvents = "auto";
    let color = this.getCellColor();
    let currentView = " ";
    if(this.props.isFlagged === true) {
      currentView = flagEmoji;
    }
    if(this.props.isRevealed === true) {
      pointerEvents = "none";
      this.showButtonClicked();
      currentView = this.props.actualValue;
    }
    let buttonTitle = "cell-[" + this.props.location + "]"
    return(
      <div id="minesweeperCell">
        <button className="unclickedButton" ref="minesweeperButton"
          data-testid={buttonTitle}
          onClick = {() => this.clickHandler(this.props.location)}
          style={{
            pointerEvents: pointerEvents,
            color: color,
            fontWeight: "bold"
          }}
        >
          {currentView}
        </button>
      </div>
    )
  }
}

export default Minesweeper;
